import { Button, Checkbox } from "@mantine/core";
import React from "react";

import { usePostApi } from "../../../../../../hooks";
import { Flex, StyledTd, StyledTr } from "../../../../../../styled";
import styles from "./TankPlansTableRow.module.scss";
import { Notification } from "../../../../../../utils/Notification";
import {
  type actionType,
  type ITankPlan,
  type IValuePair,
  orbs,
  tankTypes,
} from "../tankPlans.model";
import ConfirmationButton from "src/components/shared/ConfirmationButton/ConfirmationButton";

const StyledTankPlansTd: React.FC<React.ComponentProps<typeof StyledTd>> = ({
  className,
  ...props
}) => (
  <StyledTd
    className={`${styles.styledTankPlansTd} ${className ?? ""}`}
    {...props}
  />
);

interface Props extends ITankPlan {
  onAction: (action: actionType, rowIdx: number) => void;
  index: number;
  refetch: () => void;
}

const TankPlansTableRow = ({
  name,
  type,
  capacity,
  bwl,
  mfsbA,
  mfsbB,
  orb,
  onAction,
  index,
  tankid,
  refetch,
}: Props) => {
  const { post } = usePostApi();

  const getValue = (array: IValuePair[], value: string) =>
    array.find(el => el.value === value)?.label;

  const handleDelete = () => {
    void post({
      request: "remove-tank",
      body: { params: { tankid } },
      onSuccess: () => {
        Notification("Success", "Tank removed successfully", "green");
        refetch();
      },
    });
  };

  return (
    <StyledTr>
      <StyledTankPlansTd width="8%">
        {getValue(tankTypes, type)}
      </StyledTankPlansTd>
      <StyledTankPlansTd width="20%">{name}</StyledTankPlansTd>
      <StyledTankPlansTd width="6%">
        {capacity.value} ({capacity.unit})
      </StyledTankPlansTd>
      <StyledTankPlansTd width="30%">
        {Array.isArray(orb)
          ? orb.map(value => getValue(orbs, value)).join(", ")
          : orb}
      </StyledTankPlansTd>
      {[bwl, mfsbA, mfsbB].map((el, i) => (
        <StyledTankPlansTd
          key={`checkbox-${i}`}
          width={el === bwl ? "130px" : "150px"}>
          <Checkbox
            checked={el}
            onChange={() => {}}
            style={{ display: "flex", justifyContent: "center" }}
          />
        </StyledTankPlansTd>
      ))}
      <StyledTankPlansTd width="80px">
        <Flex direction="column" gap={5}>
          <Button
            variant="outline"
            onClick={() => onAction("add", index)}
            size="xs">
            Edit
          </Button>
          <Button
            variant="outline"
            onClick={() => onAction("history", index)}
            size="xs">
            History
          </Button>
          <ConfirmationButton
            modalText="Are you sure you wish to remove this tank plan?"
            onConfirm={handleDelete}
            buttonProps={{
              size: "xs",
              variant: "outline",
              color: "red",
            }}>
            Delete
          </ConfirmationButton>
        </Flex>
      </StyledTankPlansTd>
    </StyledTr>
  );
};

export default TankPlansTableRow;
